export default __webpack_public_path__ + "static/service_banner-08d7673f50a57913055cf9f07de034c2.webp";